import React from 'react';

import { BANNER_POSITION, bannerPositions } from '../../constants/banners';

import Classes from './BannerMid.scss';

const BannerMid = () => (
  <div
    id={bannerPositions[BANNER_POSITION.STATIC.MID].id}
    className={`${Classes.root} hz-Page-section hz-Page-section--separated`}
  />
);

export default BannerMid;
